<template>
    <div class="col-12 account-lookup-view-list">
      <div class="search-padd">
        <form v-on:submit.prevent>
          <div class="col-xs-12 override-padding">
            <div class="crm_admin_heading enterprise_affiliate_heading_1 text-align-center">&nbsp;&nbsp;</div>
            <div class="crm_admin_heading enterprise_affiliate_heading_2 text-align-left">Affiliate</div>
            <div :class="'crm_admin_heading enterprise_affiliate_heading_3 text-center'"># of Accounts</div>
            <div class="crm_admin_heading enterprise_affiliate_heading_4 text-center">Last Updated</div>
            <div class="crm_admin_heading enterprise_affiliate_heading_5 text-center">Pricing</div>
          </div>
          <div style="clear: both;"></div>
          <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div class="view-accountlist">
            <div v-if="verrors.firstByRule('affiliate', 'required')" class="margin-bottom-5 validate-warning-msg affiliate_error">Affiliate is required</div>
            <div v-if="verrors.firstByRule('pricingAffiliate', 'required')" class="margin-bottom-5 validate-warning-msg affiliate_error">Pricing Affiliate is required</div>
            <div class="tasklist-row" v-for="(affiliateList, index) in affiliateLists" :key="index" :v-if="loading === false">
              <div class="row tasklist-item col-12">
                  <div
                    class="crm_admin_field_lists enterprise_affiliate_heading_1 text-align-center">
                    <span>
                        <input type="checkbox"
                        v-bind:id="'affililate_' + index"
                        v-bind:value="affiliateList.id"
                        v-validate data-vv-rules="required"
                        name="affiliate"
                        v-model="affiliate_selected">
                    </span>
                  </div>
                  <div
                    class="crm_admin_field_lists enterprise_affiliate_heading_2 text-align-left">
                    {{ affiliateList.name }}
                  </div>
                  <div
                    :class="'crm_admin_field_lists enterprise_affiliate_heading_3 text-center'">
                    {{ affiliateList.total_accounts }}
                  </div>
                  <div 
                    class="crm_admin_field_lists enterprise_affiliate_heading_4 text-center">
                    {{ affiliateList.updated_at }}
                  </div>
                  <div
                    class="crm_admin_field_lists enterprise_affiliate_heading_5 text-align-center" v-if="affiliateList.pricing_count > 0">
                    <div class="col-6 float-left p-0 text-align-right" style="margin-left: 5px;">
                      <input
                        type="radio"
                        v-bind:id="'pricing_' + index"
                        name="pricingAffiliate"
                        v-model="pricingAffiliate"
                        v-validate data-vv-rules="required"                        
                        :value="affiliateList.id">
                    </div>
                    <div class="col-5 float-left p-0 link-text text-left" 
                      @click="showSubscriptionDetails(affiliateList.id)" style="margin-top: -1px; padding-left: 40px !important;">View</div>
                    <div style="clear: both;"></div>
                  </div>
                  <div
                    class="crm_admin_field_lists enterprise_affiliate_heading_5 text-align-center" v-else>
                    &nbsp;
                  </div> 
                  <div><hr></div>
                </div>

            </div>
          </div>

        </form>
      </div>

      <accountLookupAffiliatePriceModal :isModalVisible="isModalVisible" 
      :affiliateId="selectedAffiliatedId"
      ref="subscription_details"
      @close="isModalVisible = false">      

      </accountLookupAffiliatePriceModal>


    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import accountLookupAffiliatePriceModal from './account_lookup_affiliate_price_modal.vue'

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
      props: ['accountId'],
      data() {
        return {
          loading: false,
          affiliateLists: [],
          affiliate_selected: [],
          pricingAffiliate: '',
          selectedAffiliatedId: '',
          isModalVisible: false,
        }
      },
      components: {
        accountLookupAffiliatePriceModal,
      },
      methods: {
        showSubscriptionDetails: function(affiliateId) {
          this.selectedAffiliatedId = affiliateId;
          this.$refs.subscription_details.getSubscriptionDetails(affiliateId);
          this.isModalVisible = true;
        },
        fetchAffiliatesLists: function() {
          this.loading = true;

          axios.get('/enterprise/affiliatelists', {

          })
          .then((resp) => {
              this.loading = false;
              this.affiliateLists = resp.data;
          })
          .catch(error => {

          });
        },
        getAccountAffiliate: function() {
          axios.get('/enterprise_lookup_affiliate/' + this.accountId, {

          })
          .then((resp) => {
              if (resp.data.length > 0) {
                this.affiliate_selected = resp.data;
              } else {
                this.affiliate_selected = [];
              }
          })
          .catch(error => {

          });

          axios.get('/account_lookup_pricing_affiliate/' + this.accountId, {

          })
          .then((resp) => {
              this.pricingAffiliate = resp.data;
          })
          .catch(error => {

          });
        },
      },
      created: function () {
        this.verrors.clear();
        this.fetchAffiliatesLists();
        if (this.accountId > 0) {
          this.getAccountAffiliate();
        }
      },
      mounted() {
        EventBus.$on('VeeValidate', () => {
          this.$validator.validateAll();
        });
      },
    }
</script>


<style scoped>
.account-lookup-view-list .tasklist-item {
    padding: 3px 0px;
}
.enterprise_affiliate_heading_1 {
  width: 10%;
}
.enterprise_affiliate_heading_2 {
  width: 30%;
}
.enterprise_affiliate_heading_3 {
  width: 15%;
}
.enterprise_affiliate_heading_4 {
  width: 25%;
}
.enterprise_affiliate_heading_5 {
  width: 20%;
}
.affiliate_error { font-size: 14px; margin: 10px 0; }
.link-text {
  color: #00ACEE;
  text-decoration: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/enterprise_lookup_affiliate_tab.vue